import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t("marquee_items"), ...t("marquee_items")];
  return (
    <div data-testid="platforms-marquee" dir="ltr" className="relative border-y border-gold/15 bg-navy-800/60 py-6 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-xl md:text-2xl font-bold text-white/50 px-8">{item}</span>
            <span className="w-2 h-2 rotate-45 bg-gold/50 shrink-0" />
          </span>
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-navy-900 to-transparent" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-navy-900 to-transparent" />
    </div>
  );
}
